var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankTransferFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.63,
    height: 63.351,
    viewBox: "0 0 64.63 63.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16461",
    "data-name": "Group 16461",
    transform: "translate(-4418 8986.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16460",
    "data-name": "Group 16460",
    transform: "translate(-2946.87 3727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-bank-3543060",
    transform: "translate(7365.624 -12712.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24061",
    "data-name": "Path 24061",
    d: "M105,47.205v8.1h63.376v-8.1L136.688,30.97Zm58.849,4.119H109.527V49.494l27.161-13.927,27.161,13.927Z",
    transform: "translate(-105 -30.97)",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8063",
    "data-name": "Rectangle 8063",
    d: "M0,0H6A0,0,0,0,1,6,0V25a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(7370 -12689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8064",
    "data-name": "Rectangle 8064",
    d: "M0,0H6A0,0,0,0,1,6,0V25a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(7386 -12689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24081",
    "data-name": "Path 24081",
    d: "M0,0H6V6A3,3,0,0,1,0,6Z",
    transform: "translate(7402 -12689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24082",
    "data-name": "Path 24082",
    d: "M0,0H6V6A3,3,0,0,1,0,6Z",
    transform: "translate(7418 -12689)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8067",
    "data-name": "Rectangle 8067",
    width: 6,
    height: 64.38,
    rx: 3,
    transform: "translate(7429.25 -12656.037) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24080",
    "data-name": "Path 24080",
    d: "M164.89,187.983l-5.366,5.175a1.72,1.72,0,0,1-2.267,0,1.353,1.353,0,0,1,0-2.046l3.467-3.129H142.283a1.457,1.457,0,1,1,0-2.9h18.79l-3.892-4.05a1.352,1.352,0,0,1,.161-2.046,1.726,1.726,0,0,1,2.267.145l6.083,6.326a1.4,1.4,0,0,1,.529,1.074c0,.46-1.331,1.449-1.331,1.449Z",
    transform: "translate(4315.779 -9128.696)",
    stroke: "#000",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransferFree);
export default __webpack_public_path__ + "static/media/bank_transfer_free.d8957f0f3411d1b1ceae565f03cd189a.svg";
export { ForwardRef as ReactComponent };